import { Link } from "react-router-dom";
import styled from "styled-components/macro";

export const NakedLink = styled(Link)`
	color: inherit;
	text-decoration: none;
`;
